import './styles.css'

const Footer = () => 
  <div className="Footer">
    <span>Todos os direitos reservados - 2021</span>
    <span>Dev: Fabrício Mendes</span>
  </div>

export default Footer